import { CardList, HeroControl } from '../../client/View/viewTypes';
import {
  Card,
  CardResponse,
  Language,
  Pointer,
  View,
} from '@yleisradio/areena-types';
import { GeoLocation } from '../../client/appTypings';
import { LoggedInUser } from 'src/common/types';

export type ViewData = {
  [viewId: string]: {
    hasHero: boolean;
    tabs: {
      [tabIndex: number]: {
        lists: {
          [listIndex: number]: CardList;
        };
        heroControls: {
          heroControlPlay?: { control: HeroControl };
          heroControlInfo?: HeroControl;
        };
        slug: string | undefined;
        title: string;
      };
    };
  };
};

/**
 * Card guaranteed to include a pointer
 */
export type CardWithPointer = Card & {
  pointer: Pointer;
  menuSource?: Pointer;
};

export function isCardWithPointer(card: Card): card is CardWithPointer {
  return card.pointer !== undefined;
}

export type CardWithSubcardPointer = Card & {
  cards: Card[];
};

export type CardPageThunkResponsePayload = CardResponse & {
  languageCode: Language;
  geoLocation: GeoLocation;
  isHbbtvMode: boolean;
};

export type CardPageThunkPayload = {
  viewId: string;
  tabIndex: number;
  listIndex: number;
  pageIndex: number;
  view: View | undefined;
  userLoginCookie: string;
  user: LoggedInUser | null;
};
